<template>
  <div class="follow-area">
    <div class="feedback">
      <transition name="fade" @enter="enterSuccessFeedback">
        <FeedbackSuccess
          v-if="showableSuccessFeedback"
          :message="successMessage"
        />
      </transition>
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError v-if="showableErrorFeedback" :message="errorMessage" />
      </transition>
    </div>
    <div v-if="isFollowingStatusLoading" class="follow-area--loading">
      <SmallLoading />
    </div>
    <div v-else class="follow-area--loaded">
      <div v-if="following" class="follow__following">
        <ButtonSecondary
          text="フォロー中"
          @click-secondary-button="openModal"
        />
        <TextModal
          v-if="showModal"
          :title-text="`${nickname}さんのフォローを解除しますか？`"
          caption-text=""
          primary-button-text="フォローを解除する"
          cancel-button-text="キャンセル"
          @clicked-modal-cover="closeModal"
          @clicked-primary="unfollow"
          @clicked-cancel="closeModal"
        />
        <a :href="mypageFollowsPath" class="follow__follow-list-link">
          あなたがフォローしている人を見る
        </a>
      </div>
      <div v-else class="follow__not-following">
        <ButtonPrimary text="フォローする" @click-primary-button="follow" />
        <div class="follow__caption">
          <span>
            フォローすると「フォローしている人」の一覧ページからこのプロフィールにアクセスできるようになり、誕生日が登録・公開されている場合には、当日に通知を受けることができます。
          </span>
          <span>
            ※通知の受信にあたり、
            <a href="/mypage/settings/notifications/edit">ご自身の設定状況</a>
            をご確認ください
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackSuccess from '../../../atoms/feedbacks/feedback-success.vue'
import FeedbackError from '../../../atoms/feedbacks/feedback-error.vue'
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'
import TextModal from '../../../molecules/modals/text-modal.vue'
import ButtonPrimary from '../../../molecules/buttons/ButtonPrimary.vue'
import ButtonSecondary from '../../../molecules/buttons/ButtonSecondary.vue'

import axios from 'axios'

export default {
  components: {
    FeedbackSuccess,
    FeedbackError,
    SmallLoading,
    TextModal,
    ButtonPrimary,
    ButtonSecondary
  },
  props: {
    nickname: {
      type: String,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    isApp: {
      type: Boolean,
      required: true
    },
    mypageFollowsPath: {
      type: String,
      required: true
    },
    screenName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showableSuccessFeedback: false,
      showableErrorFeedback: false,
      successMessage: '',
      errorMessage: '',
      showModal: false,
      following: false,
      isFollowingStatusLoading: false
    }
  },
  mounted() {
    this.getFollowStatus()
  },
  methods: {
    enterSuccessFeedback() {
      setTimeout(() => {
        this.showableSuccessFeedback = false
      }, 3000)
    },
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    showFeedback(message) {
      this.showableSuccessFeedback = true
      this.successMessage = message
    },
    closeModal() {
      this.showModal = false
    },
    openModal() {
      this.showModal = true
    },
    async unfollow() {
      if (!this.isApp) {
        dataLayer.push({
          event: 'click_profile__unfollow',
          followee_user_id: this.userId,
          via: 'profile'
        })
      } else {
        logEvent('click_profile__unfollow', {
          followee_user_id: this.userId,
          via: 'profile'
        })
      }

      try {
        const res = await axios.patch('/api/v1/users/@me/follows/unfollow', {
          screen_name: this.screenName
        })
        if (res.data.status === 200) {
          this.closeModal()
          this.showFeedback('フォローを解除しました')
          this.following = false
        }
      } catch (error) {
        this.closeModal()
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    async follow() {
      if (!this.isApp) {
        dataLayer.push({
          event: 'click_profile__follow',
          followee_user_id: this.userId
        })
      } else {
        logEvent('click_profile__follow', {
          followee_user_id: this.userId
        })
      }

      try {
        const res = await axios.patch('/api/v1/users/@me/follows/follow', {
          screen_name: this.screenName
        })
        if (res.data.status === 401) {
          window.location.href = '/barista/sessions/new'
        }
        if (res.data.status === 200) {
          this.showFeedback('フォローしました')
          this.following = true
        }
      } catch (error) {
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    async getFollowStatus() {
      this.isFollowingStatusLoading = true
      try {
        const res = await axios.get(
          `/api/v1/pickup/follows/follow_status?screen_name=${this.screenName}`
        )
        if (res.data.status === 200) {
          this.following = res.data.following_status
          this.isFollowingStatusLoading = false
        }
      } catch (error) {
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.follow {
  &__follow-list-link {
    font-size: 1.6rem;
    line-height: 1.6;
    display: inline-block;
    margin-top: 16px;
  }

  &__caption {
    @extend %caption;
    margin-top: 16px;
    text-align: left;

    span {
      display: flex;
    }
  }
}
</style>
